import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import BreadCrumb from "components/Common/BreadCrumb";
import CollapseFilter from "components/Common/CollapseFilter";
import CopyWrapper from "components/Common/CopyWrapper";
import DatePickerCustom from "components/Common/DatePickerCustom";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import LabelWrapper from "components/Common/LabelWrapper";
import ModalConfirm from "components/Common/ModalConfirm";
import TableContainer from "components/Common/TableContainer";
import TooltipCustom from "components/Common/TooltipCustom";
import { useRole } from "components/Hooks/UserHooks";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import {
  COLOR_STATUS_ACTIVE_DISABLE,
  LIST_USER_PLAN_STATUS,
  STATUS_ACTIVE_DISABLE_OPTION,
} from "helpers/constans";
import { formatDateStringToKorea, formatDateStringToUTC, formatNumber } from "helpers/format";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import SectionForm from "./SectionForm";
import { useSelector } from "react-redux";
import CountUp from "react-countup";
import { isHavePermissionRole, ROLES_FOR_APP } from "helpers/role";
import CollapseContent from "components/Common/CollapseContent";
import { getSections, updateSection } from "store/section/thunk";
import sectionApi from "api/sectionApi";
import ModalPreview from "components/Common/ModalPreview";
import ModalMultiPreview from "components/Common/ModalMultiPreview";

const TYPE_SELECT_DEFAULT: string = "created_at";
registerLocale("en", en);
registerLocale("ko", ko);

const SectionManagement = () => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    sectionKey: withDefault(StringParam, ""),
    sectionName: withDefault(StringParam, ""),
    sectionShortName: withDefault(StringParam, ""),
    isActive: withDefault(StringParam, ""),
    createdFrom: withDefault(StringParam, ""),
    createdTo: withDefault(StringParam, ""),
  });

  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.createdFrom
      ? moment(query?.createdFrom || "", "Y-MM-DD").toDate()
      : null,
    query?.createdTo ? moment(query?.createdTo || "", "Y-MM-DD").toDate() : null,
  ]);
  const [createdFrom, createdTo] = dateSearch;

  const [sectionKey, setSectionKeySearch] = useState<string>(query?.sectionKey || "");
  const [sectionName, setSectionNameSearch] = useState<string>(query?.sectionName || "");
  const [sectionShortName, setSectionShortNameSearch] = useState<string>(query?.sectionShortName || "");
  const [statusSearch, setStatusSearch] = useState<any>(
    LIST_USER_PLAN_STATUS?.find((item) => item?.value === query?.isActive)
      ?.value || ""
  );

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [itemToEdit, setItemToEdit] = useState<any>(false);
  const [linkImage, setLinkImage] = useState<any>(null);
  const [dataSection, setDataSection] = useState<any>(null);

  const dispatch: any = useDispatch();
  const selectLayoutState = (state: any) => state.Section;

  const SectionProperties = createSelector(
    selectLayoutState,
    (state) => ({
      sections: state?.sections,
      isSectionLoading: state?.isSectionLoading,
      isSectionSuccess: state?.isSectionSuccess,
      error: state?.error,
    })
  );

  // Inside your component
  const { sections, isSectionLoading } = useSelector(SectionProperties);
  // console.log(sections, isSectionLoading)
  function loadTableData() {
    dispatch(getSections(query));
  }

  // Begin::Change status
  const handleOnConfirmUpdate = async (item: {
    data: any;
    isActive: string | boolean;
  }) => {
    if (!item || !item?.data?.id) return;

    try {
      const formatData = {
        isActive: item?.isActive
      }
      const response: any = await updateSection(item?.data?.id, formatData);
      if (response?.code === 200) {
        loadTableData();
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
      } else {
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 60,
        thClass: "align-middle",
        Cell: ({ ...props }) => {
          const item = props?.row?.original;
          return (
            <CopyWrapper
              contentCopy={item?.id || ""}
              style={{ display: "inline-flex", minWidth: "50px" }}
            >
              <div>
                {sections?.length - props?.row?.index}
                {/* {sections?.pagination?.total -
                  ((query?.page - 1) * query?.limit + props?.row?.index)} */}
              </div>
            </CopyWrapper>
          );
        },
      },
      {
        Header: t("Status"),
        accessor: "isActive",
        filterable: false,
        sortable: false,
        thWidth: 120,
        thClass: "align-middle text-center",
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <div
              className="form-check form-switch form-switch-sm text-center"
              dir="ltr"
              style={{ minWidth: "80px" }}
            >
              <input
                type="checkbox"
                className="form-check-input"
                name="status"
                checked={cell?.value === true}
                onChange={(e) => {
                  const value = e?.target?.checked;
                  handleOnConfirmUpdate({
                    data: item,
                    isActive: value,
                  });
                }}
              />
            </div>
          );
        },
      },
      {
        Header: t("Section Key"),
        accessor: "code",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap",
        thWidth: 150,
        Cell: (cell: any) => {
          return (
            <div className="cursor-pointer" style={{ minWidth: "150px" }}>
              {
                cell?.value ? (
                  <CopyWrapper contentCopy={cell?.value}>
                    {`${cell?.value}`}
                  </CopyWrapper>
                ) : "-"
              }
            </div>
          );
        },
      },
      {
        Header: t("Section Name"),
        accessor: "name",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (
            <div className="cursor-pointer" style={{ minWidth: "180px" }}>
              {
                cell?.value ? (
                  <div
                    className="cursor-pointer text-primary"
                    onClick={() => {
                      setIsOpen(true);
                      setItemToEdit(item);
                    }}
                  >
                    <CopyWrapper contentCopy={cell?.value}>
                      {`${cell?.value}`}
                    </CopyWrapper>
                  </div>
                ) : "-"
              }
            </div>
          );
        },
      },
      {
        Header: t("Section Full Name"),
        accessor: "fullName",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          return (
            <div className="cursor-pointer" style={{ minWidth: "180px" }}>
              {
                cell?.value ? (
                  <CopyWrapper contentCopy={cell?.value}>
                    {`${cell?.value}`}
                  </CopyWrapper>
                ) : "-"
              }
            </div>
          );
        },
      },
      {
        Header: t("Section Detail Name"),
        accessor: "detailName",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          return (
            <div className="cursor-pointer" style={{ minWidth: "180px" }}>
              {
                cell?.value ? (
                  <CopyWrapper contentCopy={cell?.value}>
                    {`${cell?.value}`}
                  </CopyWrapper>
                ) : "-"
              }
            </div>
          );
        },
      },
      {
        Header: t("Description"),
        accessor: "description",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap",
        thWidth: 260,
        Cell: (cell: any) => {
          return cell?.value ? (
            <CopyWrapper
              contentCopy={cell?.value}
              style={{ minWidth: "230px", whiteSpace: "pre-line" }}
            >
              <CollapseContent
                style={{ maxWidth: "230px" }}
                dataOriginal={cell?.value}
                isRank={false}
                isInlineBlock={true}
                isShowModal={true}
                titleModal={t("Description")}
              />
            </CopyWrapper>
          ) : "-";
        },
      },
      {
        Header: t("Price"),
        accessor: "price",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap text-end",
        thWidth: 180,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const currency = item?.currency === "KRW" ? "₩" : "$";
          const price = cell?.value;
          
          return (
            <>
              <div className="cursor-pointer text-end" style={{ minWidth: "120px" }}>
                {price ? `${formatNumber(price)} ${currency}` : "-"}
              </div>
            </>
          );
        },
      },
      {
        Header: t("Discount Rate"),
        accessor: "discountRate",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap text-end",
        thWidth: 100,
        Cell: (cell: any) => {
          return (
            <div className="cursor-pointer text-end" style={{ minWidth: "90px" }}>
              {cell?.value && `${cell?.value}%`}
            </div>
          );
        },
      },
      {
        Header: t("Final Price"),
        accessor: "priceFinal",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap text-end",
        thWidth: 180,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const currency = item?.currency === "KRW" ? "₩" : "$";
          const priceFinal = cell?.value;

          return (
            <div className="cursor-pointer text-end" style={{ minWidth: "120px" }}>
              {priceFinal ? `${formatNumber(priceFinal)} ${currency}` : "-"}
            </div>
          );
        },
      },
      {
        Header: t("Max Active Items"),
        accessor: "configs.maxActiveItems",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap text-end",
        thWidth: 120,
        Cell: (cell: any) => {
          return (
            <div className="cursor-pointer text-end" style={{ minWidth: "120px" }}>
              { cell?.value || "-" }
            </div>
          );
        },
      },
      {
        Header: t("Display Mode"),
        accessor: "configs.displayMode",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap text-center",
        thWidth: 100,
        Cell: (cell: any) => {
          const displayMode = cell?.value;

          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              {
                displayMode ? (
                  <span
                    className={`rounded-pill badge bg-${displayMode === "order" ? "primary" : "warning"}`}
                  >
                    {t(
                      displayMode === "order" ? "Order" : "Random"
                    )}
                  </span>
                ) : "-"
              }
            </div>
          )
        },
      },
      {
        Header: t("Created At"),
        accessor: "createdAt",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "align-middle text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },

      {
        Header: t("Button Action"),
        thClass: "align-middle text-center",
        thWidth: 150,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul
              className="list-inline d-flex flex-nowrap hstack gap-2 mb-0 "
              style={{ justifyContent: "center" }}
            >
              <TooltipCustom
                title={t("Button Update")}
                id={`update-md-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-primary edit-item-btn"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setItemToEdit(item);
                    setIsOpen(true);
                  }}
                >
                  <i className="ri-pencil-fill align-bottom "></i>
                </Link>
              </TooltipCustom>

              {/* <TooltipCustom
                title={t("Button Delete")}
                id={`delete-md-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-danger edit-item-btn"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setItemToDelete(item);
                  }}
                >
                  <i className="ri-delete-bin-3-fill align-bottom"></i>
                </Link>
              </TooltipCustom> */}
            </ul>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, sections?.length, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const triggerRefresh = () => {
    loadTableData();
  };

  useEffect(() => {
    loadTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, JSON.stringify(query)]);

  useEffect(() => {
    const handleCallAllOption = async () => {
      try {
        const [resSections]: any = await Promise.all([
          sectionApi.getSections()
        ]);
        if (resSections?.data) {
          const formatDataSection = resSections?.data?.map((item: any) => ({
            label: item?.fullName,
            value: item?.id
          }))
          setDataSection(formatDataSection)
        }
      } catch (error: any) {
        return error;
      }
    };
    handleCallAllOption();
  }, []);

  useEffect(() => {
    document.title = `${t("Section Menu")} | OnnyJob`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Section Menu")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-5 con-sm-6">
                      <div>
                        <h5 className="card-title mb-0">
                          <span className="me-2">{t("Total")}:</span>
                          <CountUp
                            start={0}
                            end={sections?.length || 0}
                            duration={1}
                            className="text-primary"
                          />
                        </h5>
                      </div>
                    </div>
                    {/* <div className="col-7 con-sm-6 text-end">
                      {isHavePermissionRole(
                        ROLES_FOR_APP.PLAN_MANAGEMENT_CREATE,
                        userPermissions
                      ) && (
                          <div className="col-sm-auto">
                            <div>
                              <button
                                type="button"
                                className="btn btn-success add-btn"
                                onClick={() => {
                                  setIsOpen(true);
                                  setItemToEdit(null);
                                }}
                              >
                                <i className="ri-add-line align-bottom me-1"></i>
                                {t("Create Section")}
                              </button>
                            </div>
                          </div>
                        )}
                    </div> */}
                  </Row>
                </CardHeader>
                {/* <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("Section Key")}
                          isShow={!!sectionKey}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Section Key")}...`}
                            value={sectionKey}
                            onChange={(e) => setSectionKeySearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("Section Name")}
                          isShow={!!sectionName}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Section Name")}...`}
                            value={sectionName}
                            onChange={(e) => setSectionNameSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={t("Section Description")}
                          isShow={!!sectionShortName}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Section Description")}...`}
                            value={sectionShortName}
                            onChange={(e) => setSectionShortNameSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>
                      

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("Status")} isShow={true}>
                          <DropdownStatusNew
                            name="status"
                            dataList={STATUS_ACTIVE_DISABLE_OPTION}
                            placeholder={`${t("Select Status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={statusSearch}
                            onChangeSelect={(e: any) =>
                              setStatusSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_STATUS_ACTIVE_DISABLE}
                          />
                        </LabelWrapper>
                      </Col>
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-3 mt-md-3 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!createdFrom || !!createdTo}
                        >
                          <DatePickerCustom
                            startDate={createdFrom || null}
                            endDate={createdTo || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>
                      <Col
                        sm={12}
                        md={9}
                        xl={9}
                        xxl={9}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div> */}
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={sections?.data?.length ? sections?.data : sections || []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={sections?.length || 0}
                      customPageCount={Math.ceil(
                        Number(sections?.length) / Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sortBy: query.sortBy,
                        orderBy: query.orderBy,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isSectionLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        {isOpen && (
          <SectionForm
            setIsOpen={setIsOpen}
            id={itemToEdit?.id}
            item={itemToEdit}
            setItemToEdit={setItemToEdit}
            triggerRefresh={triggerRefresh}
            dataSection={dataSection}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default SectionManagement;
